export const SessionSearchColors: string[] = [
  /* 00 */ '#00d0db',
  /* 01 */ '#6e87ff',
  /* 02 */ '#ffc37d',
  /* 03 */ '#9f75df',
  /* 04 */ '#c8d437',
  /* 05 */ '#05c17d',
  /* 06 */ '#7ae7ec',
  /* 07 */ '#c4aaeb',
  /* 08 */ '#89a6ff',
  /* 09 */ '#e2e997',
];

export const SOURCE_TYPE_CODE = 'SESSIONSEARCH';
export const SEARCHFAILED_SIGNALR_TYPE = 'SearchErrorEvent';
export const SEARCHSUCCESS_SIGNALR_TYPE = 'SearchSuccess';

export const TYPE_TO_CONTEXT_MAP: Record<string, any> = {
  Conceptual: {
    IncludePureHits: false,
    IncludeEmailThread: false,
    IncludeNearDupe: false,
    IncludeFamily: false,
    IncludeConcept: true,
  },

  PureHit: {
    IncludePureHits: true,
    IncludeEmailThread: false,
    IncludeNearDupe: false,
    IncludeFamily: false,
    IncludeConcept: false,
  },

  EmailThread: {
    IncludePureHits: false,
    IncludeEmailThread: true,
    IncludeNearDupe: false,
    IncludeFamily: false,
    IncludeConcept: false,
  },

  FamilyMember: {
    IncludePureHits: false,
    IncludeEmailThread: false,
    IncludeNearDupe: false,
    IncludeFamily: true,
    IncludeConcept: false,
  },

  NearDupe: {
    IncludePureHits: false,
    IncludeEmailThread: false,
    IncludeNearDupe: true,
    IncludeFamily: false,
    IncludeConcept: false,
  },
};
